import React from 'react';
import { Controller } from 'react-hook-form';

/**
 * LimitedAdminBlDetailsTab — Streamlined BL DETAILS tab for Limited Admin.
 * Displays ONLY File Name and BL No fields.
 */
const LimitedAdminBlDetailsTab = ({ control }) => {
  return (
    <div className="w-100">
      <h5 className="de-section-title">BL DETAILS</h5>

      <div className="row g-3">
        {/* FILE NAME */}
        <div className="col-12 col-md-6 col-lg-4">
          <div className="row align-items-center g-2">
            <label className="col-5 col-form-label de-label text-start">FILE NAME</label>
            <div className="col-7">
              <Controller
                name="fileName"
                control={control}
                render={({ field }) => (
                  <input {...field} type="text" className="form-control" placeholder="File Name" />
                )}
              />
            </div>
          </div>
        </div>

        {/* BL NO */}
        <div className="col-12 col-md-6 col-lg-4">
          <div className="row align-items-center g-2">
            <label className="col-5 col-form-label de-label text-start">BL NO :</label>
            <div className="col-7">
              <Controller
                name="billno"
                control={control}
                render={({ field }) => (
                  <input {...field} type="text" className="form-control" placeholder="BL Number" />
                )}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LimitedAdminBlDetailsTab;
